import React, { useEffect, useState } from 'react';
import bell from '../../../assets/dashboard/bell.png';
import bg from '../../../assets/dashboard/bg.jpg';
import blue from '../../../assets/dashboard/blue.png';
import coursecard from '../../../assets/dashboard/coursecard.svg';
import dot from '../../../assets/dashboard/dot.png';
import dummyImage from '../../../assets/dashboard/DummyImage.jpg';
import green from '../../../assets/dashboard/green.png';
import percentage from '../../../assets/dashboard/percentage.png';
import rates from '../../../assets/dashboard/rates.png';
import soldProducts from '../../../assets/dashboard/soldproducts.png';
import userImage from '../../../assets/dashboard/userimage.png';
import newsImg from '../../../assets/dashboard/news.png';
import groupRight from '../../../assets/dashboard/green.png';
import certIcon from '../../../assets/dashboard/coursecard.svg';

import { getMyDashboardData } from '../../../services/Trainer/trainer';
import DashboardCharts from './DashboardCharts';
import PaginatedNotifications from '../../admin/dashboard/PaginatedNotifications';



const Dashboard = () => {

  const [dashboardData , setDashboardData] = useState();

   const fetchData = async () => {
    const data = await getMyDashboardData(); 
    if (data) {
      console.log("admin profile data >>>", data);
      setDashboardData(data);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  return (
    <div className="col-md-12 main_area dashboard-main-container">
      {/* <div className="row profile_row">
        <div className="col-md-6">
          <h2 className="title_main">Dashboard</h2>
        </div>
        <div className="col-md-6">
          <div className="icon_profile text-end">
            <img src={bell} className="notification_icon" alt="bell" />
            <img src={userImage} className="profile_picture" alt="profile" />
          </div>
        </div>
      </div> */}

      <div className="row four_colums">
        <div className="col-md-3">
          <div className="image_box">
            <div className="content_box">
              <div className="dot_title">
                <img src={dot} alt="dot" className="dot" />
                <p className='ps-2'>Products Sold</p>
              </div>
              <h4 className="mt-2">{dashboardData?.productSolds}</h4>
            </div>
            <div className="img_icon">
              <img src={soldProducts} alt="sold products" />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="image_box">
            <div className="content_box">
              <div className="dot_title">
                <img src={green} alt="dot" className="dot" />
                <p className='ps-2'>Memberships Sold</p>
              </div>
              <h4 className="mt-2">{dashboardData?.membershipSolds}</h4>
            </div>
            <div className="img_icon">
              <img src={rates} alt="rates" />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="image_box">
            <div className="content_box">
              <div className="dot_title">
                <img src={blue} alt="dot" className="dot" />
                <p className='ps-2'>Rebooking Rate %</p>
              </div>
              <h4 className="mt-2">{dashboardData?.averageRatings}%</h4>
            </div>
            <div className="img_icon">
              <img src={percentage} alt="percentage" />
            </div>
          </div>
        </div>
        <div className="col-md-3">
           <a
                href="https://partners.fresha.com/users/sign-in"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
          <div className="image_box">
            <div className="content_box">
              
                <h2 className="mt-2">Fresha</h2>
           
            </div>
          </div>
          </a>
        </div>
      </div>

      <div className="Graph_section py-5 text-center">
        <DashboardCharts userData={dashboardData}/>
        {/* <img src={dummyImage} className="img-fluid" alt="graph" /> */}
      </div>

   <div className="dashboard-notification py-5 ">
      <h3 className="chart-title mb-4" style={{color:'#72675B', fontWeight:'700'}}>Notifications</h3>
        {/* {dashboardData?.notifications.length > 0 && dashboardData?.notifications.map((item) => {
          // Helper function to get notification icon based on message type
        const getNotificationIcon = (message) => {
        if (message.includes('reacted') || message.includes('liked')) {
          return (
            <div className="notification-icon like-icon">
              <i className="bi bi-hand-thumbs-up-fill"></i>
            </div>
          );
        } else if (message.includes('completed') || message.includes('updated')) {
          return (
            <div className="notification-icon completed-icon">
              <i className="bi bi-check-circle-fill"></i>
            </div>
          );
        } else {
          return (
            <div className="notification-icon default-icon">
              <i className="bi bi-bell-fill"></i>
            </div>
          );
        }
      };

          // Helper function to format time
          const formatTime = (dateString) => {
            const date = new Date(dateString);
            return date.toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true
            });
          };

          // Helper function to format date
          const formatDate = (dateString) => {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-GB', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            });
          };

          return (
            <div key={item._id} className="notification-item mb-4">
              <div className="notification-content">
                <div className="notification-left">
                  {getNotificationIcon(item.message)}
                  <div className="notification-details">
                    <div className="notification-header">
                      <span className="notification-time">
                        {formatTime(item.createdAt)}
                      </span>
                      <span className="online-indicator"></span>
                    </div>
                    <div className="notification-text">
                      <span className="user-name" style={{ paddingRight: '5px' }}>{item.user?.fullName || 'Unknown'}</span>
                      <span className="notification-action">
                        {item.message.replace(item.user?.fullName, '').trim()}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="notification-date">
                  {formatDate(item.createdAt)}
                </div>
              </div>
            </div>
          );
        })} */}
         <PaginatedNotifications />
      </div>
      
      {/* <div className="updates row">
        <h2 className="heading">Updates</h2>
        <div className="col-md-9">
          <div className="news_announcement">
            {[1, 2].map((_, index) => (
              <div className="news_box" key={index}>
                <div className="news_image">
                  <img src={newsImg} className="img-fluid" alt="news" />
                  <div className="row py-4">
                    <div className="col-6">
                      <h3>News</h3>
                    </div>
                    <div className="col-6 text-end">
                      <div className="users_rating">
                        <i className="bi bi-people"></i>
                        <span> 120</span>
                        <i className="bi bi-star" style={{ color: '#FFBF00' }}></i>
                      </div>
                    </div>
                  </div>
                  <p>Three month course to learn the basics of python and start coding.</p>
                  <div className="row py-4">
                    <div className="col-6">
                      <div className="user_image_details">
                        <img src={userImage} width="60px" alt="mentor" />
                        <span className="text_details">
                          <strong>Black, Marvin</strong><br />
                          Mentor
                        </span>
                      </div>
                    </div>
                    <div className="col-6 text-end">
                      <span className="text_details">
                        17 Lessons<br />
                        50 Hours
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="col-md-3">
          <img src={groupRight} className="img-fluid" alt="side graphic" />
        </div>
      </div>

      <div className="container mt-5">
        <table className="table table-bordered text-center align-middle">
          <thead>
            <tr>
              <th>Sr#</th>
              <th>Course Name</th>
              <th>Courses Status</th>
              <th>Completion%</th>
              <th>Score%</th>
              <th>View Certificate</th>
            </tr>
          </thead>
          <tbody>
            {[1, 2, 3, 4].map((item) => (
              <tr key={item}>
                <td>{item}</td>
                <td>Course Name</td>
                <td><span className="status-badge">Completed</span></td>
                <td>
                  <div className="circle-progress">100%</div>
                </td>
                <td className="d-flex justify-content-center align-items-center">
                  <div className="score-bar-container">
                    <div className="score-bar"></div>
                  </div>
                  <span className="score-label">98%</span>
                </td>
                <td>
                  <div className="cert-icon">
                    <img src={certIcon} width="50px" alt="certificate" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div> */}
    </div>
  );
};

export default Dashboard;
